import { Descriptions, Table, Tag, Typography, Button, Input } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import React, { CSSProperties, useEffect, useState, useRef, ReactElement } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { chineseDrugLink, plantDetailLink } from '../hooks/TableLink';
import _ from 'lodash';
import useFetch from '../hooks/fetcher';

// import mockImg from '../img/herb/mockImg.png';
const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';
const DATA_SERVICE_BASE_URL = process.env.REACT_APP_DATA_SERVICE_BASE_URL || '';

const { Title } = Typography;
const { Text } = Typography;
const { Item } = Descriptions;
const filterIcon = (filtered: any) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;
const renderHighlightText = (text: any, searchText: string) => (
    <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text.toString()}
    />
);
type herbDetail = {
    botanical_name: string;
    pinyin: string;
    chinese_pharmaceutical_name: string;
    pharmaceutical_latin_name: string;
    used_part: string;
    chp_2015: string;
};
type ChineseDrugsType = {
    herb_basic_info: herbDetail[];
};

const PageAnimalMineralProducts: React.FC = () => {
    const [result, setResult] = useState<ChineseDrugsType>();
    const { tcm_types } = useParams<any>();
    const { get } = useFetch(API_SERVICE_BASE_URL);
    const history = useHistory();
    console.log(tcm_types);
    const [searchText, setSearchText] = useState('');
    const searchInput = useRef<Input>(null);

    const handleSearch = (selectedKeys: any, confirm: VoidFunction, dataIndex: string): void => {
        setSearchText(selectedKeys[0]);
        confirm();
    };

    const handleReset = (clearFilters: any) => {
        setSearchText('');
        clearFilters();
    };

    const filterDropdown = (
        setSelectedKeys: any,
        selectedKeys: any,
        confirm: any,
        clearFilters: any,
        dataIndex: string,
    ) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={searchInput}
                // placeholder={`Search pinyin`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90, marginRight: 8 }}
            >
                Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                Reset
            </Button>
        </div>
    );
    const columnHerbDetail: ColumnProps<any>[] = [
        {
            title: 'Botanical Name',
            key: 'botanical_name',
            dataIndex: 'botanical_name',
            filterIcon: (filtered) => filterIcon(filtered),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
                filterDropdown(setSelectedKeys, selectedKeys, confirm, clearFilters, 'botanical_name'),
            onFilter: (value, record) =>
                record['botanical_name'].toString().toLowerCase().includes(value.toString().toLowerCase()),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    setTimeout(() => {
                        if (searchInput.current) {
                            searchInput.current.focus();
                        }
                    });
                }
            },
            render: plantDetailLink,
        },
        {
            title: 'Pin Yin',
            key: 'pinyin',
            dataIndex: 'pinyin',
            filterIcon: (filtered) => filterIcon(filtered),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
                filterDropdown(setSelectedKeys, selectedKeys, confirm, clearFilters, 'pinyin'),
            onFilter: (value, record) =>
                record['pinyin'].toString().toLowerCase().includes(value.toString().toLowerCase()),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    setTimeout(() => {
                        if (searchInput.current) {
                            searchInput.current.focus();
                        }
                    });
                }
            },
            // render: (text: any): ReactElement => renderHighlightText(text, searchText),
            render: chineseDrugLink,
        },
        {
            title: 'Chinese Pharmaceutical Name',
            key: 'chinese_pharmaceutical_name',
            dataIndex: 'chinese_pharmaceutical_name',
            filterIcon: (filtered) => filterIcon(filtered),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
                filterDropdown(setSelectedKeys, selectedKeys, confirm, clearFilters, 'chinese_pharmaceutical_name'),
            onFilter: (value, record) =>
                record['chinese_pharmaceutical_name'].toString().toLowerCase().includes(value.toString().toLowerCase()),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    setTimeout(() => {
                        if (searchInput.current) {
                            searchInput.current.focus();
                        }
                    });
                }
            },
            render: chineseDrugLink,
        },
        {
            title: 'Pharmaceutical Latin Name',
            key: 'pharmaceutical_latin_name',
            dataIndex: 'pharmaceutical_latin_name',
        },
        {
            title: 'Used Part',
            key: 'used_part',
            dataIndex: 'used_part',
        },
        {
            title: 'Chinese Pharmacopedia',
            key: 'chp_2015',
            dataIndex: 'chp_2015',
        },
    ];
    useEffect(() => {
        let type = 'animal/mineral products';
        if (tcm_types == 1) {
            type = 'fungal/plant products';
        }
        get('/api/animal_mineral_table.php', { tcm_types: type }).then((r) => setResult(r));
    }, []);
    return (
        <div>
            <Title level={3}>Animal/Mineral Products List</Title>
            <Table columns={columnHerbDetail} dataSource={result?.herb_basic_info} style={{ marginBottom: '7vh' }} />
        </div>
    );
};
export default PageAnimalMineralProducts;
